export default {
  falm: 'Free Access to Law Movement',
  hklii23: 'HKLII 2023',
  banner_text: 'HKLII thanks our sponsors for supporting the <b>“Free Access to Law Movement: HKLII 2023”</b> campaign!',
  banner_btn: 'Our Sponsors',
  intro: '<p>For more than 20 years, HKLII has been providing free access to legal information in Hong Kong. We cannot keep up our work without your generous sponsorship.</p><p>A number of organisations and individuals have contributed valuable funding assistance to HKLII to continue its development. Listed below are sponsors to HKLII listed in alphabetical order.</p><p>Our heartfelt gratitude for your sponsorship and support to HKLII.</p>',
  sponsorcall: 'Become a sponsor',
  sponsorintro: 'We sincerely invite you to sponsor the “Free Access to Law Movement: HKLII 2023” on the following terms (present – 31 December 2023):',
  term_recog_long: 'Sponsorship recognition on HKLII website with:',
  term_recog_short: 'Sponsorship recognition on HKLII website',
  term_name: 'Company name hyperlinked to sponsor’s website',
  term_logo: 'Company logo ({0}) hyperlinked to sponsor’s website',
  term_logo_l: 'large',
  term_logo_m: 'medium',
  term_logo_s: 'small',
  term_promo: 'Company name/logo on other promotional materials (e.g. event leaflet)',
  tier_diamond: 'Diamond Sponsors',
  tier_diamond_amt:'HK$50,000 or above',
  tier_platinum: 'Platinum Sponsors',
  tier_platinum_amt:'HK$30,000 – HK$49,999',
  tier_gold: 'Gold Sponsors',
  tier_gold_amt:'HK$10,000 – HK$29,999',
  tier_other: 'Other Sponsors',
  tier_other_amt:'Below HK$10,000',
  tax_deduction: 'Sponsorships to “Free Access to Law Movement: HKLII 2023”, like other donations to The University of Hong Kong, are tax deductible under Section 88 of the Inland Revenue Ordinance.',
  donateonline: 'Online Donation',
  cheque_title:'By Cheque',
  cheque_text:'Please send cheques payable to “The University of Hong Kong” to Ms Rachel Li of our office at:',
  cheque_addr:'10/F Cheng Yu Tung Tower<br/>The University of Hong Kong<br/>Pokfulam Road<br/>Hong Kong',
  enquire: 'For enquiries, please contact Ms Rachel Li at <a href="mailto:lirachel@hku.hk">lirachel@hku.hk</a>.',
}